import { useState, useEffect, useCallback } from 'react';
import { useGetRequest } from '../useGetRequest/useGetRequest';
import { getCombosEvaluacionesAPI, getCombosCargosAPI } from '../../consumers/backendApisUrls';

export const useEvaluacionCombos = () => {
  const [executeGetRequest] = useGetRequest(); // ✅ Array destructuring como en otros lugares
  const [combos, setCombos] = useState({
    tiposEvaluacion: [],
    tiposCargo: [],
    cargos: [] // ✅ Lista de cargos específicos
  });
  const [loading, setLoading] = useState(true);
  const [loadingCargos, setLoadingCargos] = useState(false); // ✅ Loading específico para cargos
  const [error, setError] = useState(null);

  // ✅ Función helper para limpiar caracteres especiales mal codificados (MEMORIZADA)
  const limpiarTexto = useCallback((texto) => {
    if (!texto) return '';
    return texto
      .replace(/Ã"N/g, 'ÓN')  // Fix para ASISTENTE EDUCACIÃ"N → ASISTENTE EDUCACIÓN
      .replace(/Ã±/g, 'ñ')     // ñ mal codificada
      .replace(/Ã¡/g, 'á')     // á mal codificada  
      .replace(/Ã©/g, 'é')     // é mal codificada
      .replace(/Ã­/g, 'í')     // í mal codificada
      .replace(/Ã³/g, 'ó')     // ó mal codificada
      .replace(/Ãº/g, 'ú');    // ú mal codificada
  }, []); // ✅ Sin dependencias, función pura

  const cargarCombos = async () => {
    setLoading(true);
    setError(null);
    
    try {
      console.log('🔄 Cargando combos de evaluaciones...');
      const response = await executeGetRequest(getCombosEvaluacionesAPI());
      
      console.log('📊 Respuesta de combos:', response);
      console.log('📋 Datos de combos:', response?.data?.data?.Data);
      
      if (response && response.data && response.data.data && response.data.data.Data) {
        const combosData = response.data.data.Data;
        
        // Mapear tipos de evaluación con texto limpio
        const tiposEvaluacion = (combosData.tipoEvaluacion || []).map(tipo => ({
          value: tipo.id,
          label: limpiarTexto(tipo.nombre),
          id: tipo.id,
          nombre: limpiarTexto(tipo.nombre)
        }));
        
        // Mapear tipos de cargo con texto limpio
        const tiposCargo = (combosData.tipoCargo || []).map(cargo => ({
          value: cargo.id,
          label: limpiarTexto(cargo.nombre),
          id: cargo.id,
          nombre: limpiarTexto(cargo.nombre)
        }));
        
        setCombos(prev => ({
          ...prev,
          tiposEvaluacion,
          tiposCargo
        }));
        
        console.log('✅ Combos cargados exitosamente desde API:', {
          tiposEvaluacion: tiposEvaluacion.length,
          tiposCargo: tiposCargo.length,
          tiposDetalle: tiposEvaluacion.map(te => ({ id: te.id, label: te.label })),
          cargosDetalle: tiposCargo.map(tc => ({ id: tc.id, label: tc.label }))
        });
        
      } else {
        console.error('❌ Estructura de respuesta de combos inválida:', response);
        // Usar datos por defecto en caso de error
        setCombos(prev => ({
          ...prev,
          tiposEvaluacion: [
            { value: 248801, label: 'Psicologica', id: 248801, nombre: 'Psicologica' },
            { value: 248802, label: 'Conocimientos', id: 248802, nombre: 'Conocimientos' },
            { value: 248803, label: 'Otros', id: 248803, nombre: 'Otros' }
          ],
          tiposCargo: [
            { value: 1, label: 'DOCENTE', id: 1, nombre: 'DOCENTE' },
            { value: 2, label: 'ASISTENTE EDUCACIÓN', id: 2, nombre: 'ASISTENTE EDUCACIÓN' },
            { value: 3, label: 'OTROS', id: 3, nombre: 'OTROS' }
          ]
        }));
        console.warn('⚠️ Usando combos por defecto debido a error de estructura');
      }
      
    } catch (error) {
      console.error('❌ Error al cargar combos:', error);
      setError(error);
      
      // Usar datos por defecto en caso de error
      setCombos(prev => ({
        ...prev,
        tiposEvaluacion: [
          { value: 248801, label: 'Psicologica', id: 248801, nombre: 'Psicologica' },
          { value: 248802, label: 'Conocimientos', id: 248802, nombre: 'Conocimientos' },  
          { value: 248803, label: 'Otros', id: 248803, nombre: 'Otros' }
        ],
        tiposCargo: [
          { value: 1, label: 'DOCENTE', id: 1, nombre: 'DOCENTE' },
          { value: 2, label: 'ASISTENTE EDUCACIÓN', id: 2, nombre: 'ASISTENTE EDUCACIÓN' },
          { value: 3, label: 'OTROS', id: 3, nombre: 'OTROS' }
        ]
      }));
      
      console.warn('⚠️ Usando combos por defecto debido a error del servidor');
      
    } finally {
      setLoading(false);
    }
  };

  // ✅ FUNCIÓN PARA CARGAR CARGOS ESPECÍFICOS BASADOS EN TIPO DE CARGO (MEMORIZADA)
  const cargarCargosPorTipo = useCallback(async (idTipoCargo) => {
    if (!idTipoCargo) {
      // Limpiar cargos si no hay tipo seleccionado
      setCombos(prev => ({ ...prev, cargos: [] }));
      return;
    }

    setLoadingCargos(true);
    
    try {
      console.log('🔄 Cargando cargos para tipo:', idTipoCargo);
      const response = await executeGetRequest(getCombosCargosAPI(idTipoCargo));
      
      console.log('📊 Respuesta de cargos:', response);
      
      if (response && response.data && response.data.data && response.data.data.Data) {
        const cargosData = response.data.data.Data;
        
        // Mapear cargos específicos con texto limpio
        const cargos = cargosData.map(cargo => ({
          value: cargo.id,
          label: limpiarTexto(cargo.nombre),
          id: cargo.id,
          nombre: limpiarTexto(cargo.nombre)
        }));
        
        setCombos(prev => ({ ...prev, cargos }));
        
        console.log('✅ Cargos cargados exitosamente:', {
          idTipoCargo,
          cantidadCargos: cargos.length,
          cargosDetalle: cargos.slice(0, 5).map(c => ({ id: c.id, label: c.label })) // Solo primeros 5 para logging
        });
        
      } else {
        console.error('❌ Estructura de respuesta de cargos inválida:', response);
        setCombos(prev => ({ ...prev, cargos: [] }));
      }
      
    } catch (error) {
      console.error('❌ Error al cargar cargos:', error);
      setCombos(prev => ({ ...prev, cargos: [] }));
      
    } finally {
      setLoadingCargos(false);
    }
  }, [executeGetRequest, limpiarTexto]); // ✅ Dependencias para evitar recreación

  useEffect(() => {
    cargarCombos();
  }, []);

  const getTipoEvaluacionById = (id) => {
    console.log('🔍 getTipoEvaluacionById llamado con:', id, typeof id);
    console.log('🔍 Combos disponibles:', combos.tiposEvaluacion?.map(te => ({ 
      id: te.id, 
      idType: typeof te.id,
      value: te.value, 
      valueType: typeof te.value,
      label: te.label 
    })));
    
    // Buscar por múltiples campos para mayor flexibilidad
    const resultado = combos.tiposEvaluacion.find(tipo => 
      tipo.id === id || 
      tipo.value === id ||
      tipo.id === parseInt(id) || 
      tipo.value === parseInt(id) ||
      // Intento de mapeo si hay desajuste de IDs (1=248801, 2=248802, 3=248803)
      (id === 1 && tipo.id === 248801) ||
      (id === 2 && tipo.id === 248802) ||
      (id === 3 && tipo.id === 248803)
    );
    
    console.log('🎯 Resultado getTipoEvaluacionById:', resultado);
    return resultado;
  };

  const getTipoCargoById = (id) => {
    console.log('🔍 getTipoCargoById llamado con:', id, typeof id);
    console.log('🔍 Cargos disponibles:', combos.tiposCargo?.map(tc => ({ 
      id: tc.id, 
      idType: typeof tc.id,
      value: tc.value, 
      valueType: typeof tc.value,
      label: tc.label 
    })));
    
    // Buscar por múltiples campos para mayor flexibilidad  
    const resultado = combos.tiposCargo.find(cargo => 
      cargo.id === id || 
      cargo.value === id ||
      cargo.id === parseInt(id) || 
      cargo.value === parseInt(id)
    );
    
    console.log('🎯 Resultado getTipoCargoById:', resultado);
    return resultado;
  };

  return {
    combos,
    loading,
    loadingCargos, // ✅ Estado de carga específico para cargos
    error,
    cargarCombos,
    cargarCargosPorTipo, // ✅ Función para cargar cargos por tipo
    getTipoEvaluacionById,
    getTipoCargoById
  };
};